import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Btn, InputField } from './UIComponents';

// Export TeamModal as default
export function TeamModal({ onClose, staff, isEdit }) {
  const { B } = useTheme();

  const modalStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  };

  const modalContentStyle = {
    background: B.cardBg,
    borderRadius: 16,
    width: '100%',
    maxWidth: 500,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    '@media (maxWidth: 768px)': {
      width: '90%',
      padding: 16,
    },
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 12,
    '@media (maxWidth: 768px)': {
      gridTemplateColumns: '1fr',
    },
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 16,
    '@media (maxWidth: 768px)': {
      flexDirection: 'column',
      gap: 8,
    },
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 20 }}>
          {isEdit ? 'Edit Staff Member' : 'Add Staff Member'}
        </div>
        <div style={gridStyle}>
          <InputField label="First Name" placeholder="First name" />
          <InputField label="Last Name" placeholder="Last name" />
          <InputField
            label="Role"
            select
            options={[
              'Select…',
              'Nurse Manager',
              'RN',
              'LPN',
              'CNA',
              'Care Aide',
              'Activity Coord.',
              'Administrator'
            ]}
          />
          <InputField
            label="Department"
            select
            options={[
              'Select…',
              'Nursing',
              'Care',
              'Activities',
              'Administration'
            ]}
          />
          <InputField label="Email" placeholder="email@fch.org" />
          <InputField label="Phone" placeholder="(xxx) xxx-xxxx" />
          <InputField label="Hire Date" type="date" />
          <InputField label="Scheduled Hours/Week" placeholder="40" />
        </div>
        <div style={buttonContainerStyle}>
          <Btn outline color={B.muted} onClick={onClose}>
            Cancel
          </Btn>
          <Btn color={B.navy}>
            {isEdit ? 'Update Staff' : 'Add Staff Member'}
          </Btn>
        </div>
      </div>
    </div>
  );
}

// Export ViewTeamModal as a named export
export function ViewTeamModal({ staff: s, onClose }) {
  const { B } = useTheme();
  if (!s) return null;

  const modalStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  };

  const modalContentStyle = {
    background: B.cardBg,
    borderRadius: 16,
    width: '100%',
    maxWidth: 480,
    padding: 28,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    '@media (maxWidth: 768px)': {
      width: '90%',
      padding: 16,
    },
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    '@media (maxWidth: 768px)': {
      gridTemplateColumns: '1fr',
    },
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 20,
    '@media (maxWidth: 768px)': {
      flexDirection: 'column',
      gap: 8,
    },
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
          <div style={{
            width: 50,
            height: 50,
            borderRadius: '50%',
            background: s.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 16,
            fontWeight: 700,
            color: '#fff'
          }}>
            {s.initials}
          </div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: B.navy }}>{s.name}</div>
            <div style={{ fontSize: 12, color: B.muted }}>{s.role}</div>
          </div>
        </div>
        <div style={gridStyle}>
          <div style={{ background: B.bg, borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 9, color: B.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>
              Status
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: B.green }}>{s.status}</div>
          </div>
          <div style={{ background: B.bg, borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 9, color: B.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>
              Clock In
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: B.navy }}>{s.clockIn}</div>
          </div>
          <div style={{ background: B.bg, borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 9, color: B.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>
              Hours This Week
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: B.navy }}>{s.hoursWeek}h</div>
          </div>
          <div style={{ background: B.bg, borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 9, color: B.muted, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>
              Overtime
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: s.overtime > 0 ? '#dc2626' : B.green }}>
              {s.overtime}h
            </div>
          </div>
        </div>
        <div style={buttonContainerStyle}>
          <Btn outline color={B.muted} onClick={onClose}>
            Close
          </Btn>
          <Btn color={B.navy}>
            Edit Profile
          </Btn>
        </div>
      </div>
    </div>
  );
}